module.exports = __webpack_public_path__ + "static/media/safe_secure_journey.5eaef891.svg";